export default __webpack_public_path__ + "static/media/usability.e32caba0.jpg";